import {useContext, useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import ActionButton, {atomActionButtonColors, atomActionButtonStyles} from '@s-ui/react-atom-action-button'
import AtomVideoPlayer from '@s-ui/react-atom-video-player'
import Context from '@s-ui/react-context'
import ShrinkAlt from '@adv-mt/mt-svg-icons/lib/ShrinkAlt'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {BASE_CLASS} from '../config.js'

const VideoPlayer = ({dealerId, isMobile, isPlaying, onClosePlayer, src, title}) => {
  const {domain} = useContext(Context)
  const {track} = useAnalyticsTrack()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const config = domain.get('config')
  const isFullSize = isMobile && isPlaying

  const mainClassName = cx(`${BASE_CLASS}-overlay`, {
    'is-fullwidth': isFullSize
  })

  const emitVideoPlayEvent = async () => {
    const {
      TRACKING_EVENT_NAMES: {DEALER_VIDEO_PLAYED}
    } = config.get('tracking')
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      event: DEALER_VIDEO_PLAYED,
      context: dealerId
    })

    track(eventData)
  }

  return (
    <div className={mainClassName}>
      {isFullSize ? (
        <ActionButton
          className={`${BASE_CLASS}-fullSizeActionBtn`}
          color={atomActionButtonColors.PRIMARY}
          icon={<ShrinkAlt />}
          onClick={onClosePlayer}
          style={atomActionButtonStyles.FILLED_POSITIVE}
        />
      ) : null}
      <div className={`${BASE_CLASS}-video`}>
        {isMounted && (
          <AtomVideoPlayer
            autoPlay={isPlaying}
            controls={true}
            src={src}
            title={title}
            playsInline={true}
            muted={true}
            onLoadVideo={emitVideoPlayEvent}
          />
        )}
      </div>
    </div>
  )
}

VideoPlayer.propTypes = {
  dealerId: PropTypes.string,
  isMobile: PropTypes.bool,
  isPlaying: PropTypes.bool,
  onClosePlayer: PropTypes.func,
  src: PropTypes.string,
  title: PropTypes.string
}

export default VideoPlayer
